import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { IMAGES, LINKS } from '../data/site';
const PROOF = ['Established 1991', 'Tools & equipment', 'Hands-on training', 'Custom fabrication'];
export function Hero() {
  return <section className="bg-charcoal text-cream" aria-labelledby="hero-heading" data-id="element-173" data-mp="9ll64omrvija">
      <div className="mx-auto grid max-w-[1240px] gap-8 px-5 py-10 sm:px-8 lg:grid-cols-2 lg:items-center lg:gap-12 lg:py-16" data-id="element-174" data-mp="4mru70n4vzl8">
        <div className="max-w-[560px]" data-id="element-175" data-mp="128z0qg300208">
          <p className="font-display text-[13px] uppercase tracking-eyebrow text-fred sm:text-[14px]" data-id="element-176" data-mp="xannrwhepbds">
            The craft. The tools. The know-how.
          </p>
          <h1 id="hero-heading" className="mt-5 font-display text-[40px] font-bold uppercase leading-[0.94] tracking-[-0.01em] text-white sm:text-[62px] lg:text-[64px]" data-id="element-177" data-mp="s9giq56neqat">
            Metal shaping tools,
            <br data-id="element-178" data-mp="382p55bt4dbkm" />
            workshops &amp;
            <br data-id="element-179" data-mp="380vz9yqbyvdo" />
            <span className="text-fred" data-id="element-180" data-mp="384jsewrv5frv">custom fabrication</span>
          </h1>
          <p className="mt-6 max-w-[46ch] text-[16px] leading-relaxed text-steel-200 sm:text-[17px]" data-id="element-181" data-mp="3j9265qny7uwl">
            Specialist metal shaping tools, hands-on workshops and custom fabrication, backed by practical
            shop experience in Mt. Clemens, Michigan.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-182" data-mp="3e8egp9fdbm4h">
            <a href={LINKS.shopAll} className="inline-flex min-h-[52px] items-center bg-fred px-7 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-fred-dark" data-id="element-183" data-mp="30iaziwvciilw">
              Shop Metalworking Tools
            </a>
            <a href={LINKS.workshops} className="inline-flex min-h-[52px] items-center border border-steel-400 px-7 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:border-cream hover:bg-white/5" data-id="element-184" data-mp="2vi53l4i1m9y0">
              Explore Workshops
            </a>
          </div>
          <a href={LINKS.fabrication} className="mt-5 inline-flex min-h-[44px] items-center gap-2 text-[15px] text-steel-200 underline decoration-steel-600 underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:decoration-fred" data-id="element-185" data-mp="s3ur9xru3ab5">
            Discuss a custom project
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-186" data-mp="1b1fgj5yigawa" />
          </a>

          <ul className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/10 pt-5 text-[12px] uppercase tracking-[0.12em] text-steel-400" data-id="element-187" data-mp="161t0ypv7mikb">
            {PROOF.map(item => <li key={item} data-id="element-188" data-mp="x14kzpm9a84s">{item}</li>)}
          </ul>
        </div>

        <div className="relative lg:translate-y-[-12px]" data-id="element-189" data-mp="x3h2y2s0kihu">
          <div className="relative aspect-[852/342] w-full overflow-hidden bg-black lg:max-w-[650px]" data-id="element-190" data-mp="3ltqdrg1k11v3">
            <img src={IMAGES.hero} width={852} height={432} alt="Hands using a mallet to shape a curved silver metal panel in the Fournier shop" fetchPriority="high" className="absolute left-0 top-0 h-auto w-full max-w-none" data-id="element-191" data-mp="3hqkckmtau0vh" />
          </div>
          <div aria-hidden="true" className="mt-3 h-[3px] w-24 bg-fred" data-id="element-192" data-mp="26867y30hbtb4" />
        </div>
      </div>
    </section>;
}